import {Component, computed, input, model} from '@angular/core';
import {MatOption, MatSelect} from '@angular/material/select';
import {AvatarComponent} from '../avatar/avatar.component';

export interface Person<T extends number | string = number> {
    id: T;
    name: string;
    /** Shown after the name, e.g. "(jij)". */
    suffix?: string;
}

/** Avatar + mat-select with the people, plus ▲▼ buttons to step through the list. */
@Component({
    selector: 'app-person-switcher',
    imports: [AvatarComponent, MatSelect, MatOption],
    templateUrl: './person-switcher.component.html',
    styleUrl: './person-switcher.component.scss'
})
export class PersonSwitcherComponent<T extends number | string = number> {
    readonly people = input<Person<T>[]>([]);
    readonly value = model<T | null>(null);
    readonly label = input('Medewerker');

    readonly selected = computed(() => this.people().find(person => person.id === this.value()));

    step(direction: 1 | -1) {
        const people = this.people();
        if (!people.length) {
            return;
        }
        const index = people.findIndex(person => person.id === this.value());
        const next = (index + direction + people.length) % people.length;
        this.value.set(people[next].id);
    }
}
